import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";
import { urlAttendanceSecured, urlAttendanceAllSecured } from "../../api/urls";
import { PAGE_SIZE_9 } from "../../constants/index";

const generateFilterQuery = (filters) => {
  let filter = "?";
  const page = filters.page;
  const pageSize = filters.pageSize;
  const sort = filters.sort;
  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_9);

  if (filters) {
    if (filters.uuid !== undefined) filter += "&uuid=" + filters.uuid;
    if (filters.sessionUuid !== undefined)
      filter += "&sessionUuid=" + filters.sessionUuid;
  }
  if (sort) filter += "&sort=" + sort;
  return filter;
};

/**
 * Filter list attendances.
 */
export const filterAttendance = createAction("FILTER_ITEMS", (filter, param) =>
  apiGet(urlAttendanceAllSecured + generateFilterQuery(filter), param, true)()
);
/*export const filterAttendance = createAction(
  "FILTER_ATTENDANCES",
  (filter, param) =>
    apiGet(
      urlAttendanceAllSecured +
        `?sessionUuid=${filter.sessionUuid}&pageSize=${PAGE_SIZE_10}`,
      param,
      true
    )()
);*/

/**
 * Get a attendance.
 */
export const get = createAction("GET_ATTENDANCE", (param) =>
  apiGet(urlAttendanceSecured, param, true)()
);

/**
 * Create attendance.
 */
export const createAttendance = createAction("REGISTER_ATTENDANCE", (obj) => {
  apiPost(urlAttendanceSecured, obj, undefined, true)();
});

/**
 * Update attendance.
 */
export const update = createAction("UPDATE_ATTENDANCE", (obj, param) =>
  apiPut(urlAttendanceSecured, param, obj, true)()
);

/**
 * Delete attendance.
 */
export const removeAttendance = createAction("DELETE_ATTENDANCE", (param) =>
  apiDelete(urlAttendanceSecured, param, true)()
);
